import React, { Component } from 'react';
import { Modal, Glyphicon } from 'react-bootstrap';
import './App.css';
import './index.css';

export default class SearchModal extends Component {
    constructor(props) {
        super(props);

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.chooseLoc = this.chooseLoc.bind(this);

        this.state = {
            showModal: false,
            searchedTerm: 'Search for a Location...'
        }
    }

    // Updates the state var searchedTerm to the input value
    updateSearch(event) {
        this.setState({
            searchedTerm: event.target.value.substr(0, 25)
        });
    }

    // Runs when a user selects a location in the search modal
    chooseLoc(loc) {
        let jsonData = require('./json/' + loc + '.json');
        let lat = jsonData.position.lat;
        let lng = jsonData.position.lng;

        // center map around location the user has chosen
        this.props.changeCenter({lat: lat, lng: lng});

        // close search modal
        this.setState({ showModal: false });

        // change has to location so Main.js can take care of it
        window.location.hash = loc;
    }

    open() {
        this.props.hideNavBar();
        window.location.hash = "#search";
    }

    close() {
        window.location.hash = "";
        this.setState({ showModal: false });
    }

render() {
    let newMarkers = this.props.markers;
    let filteredLocs = Object.keys(newMarkers).filter(
        (loc) => {
            return newMarkers[loc].name.toLowerCase().indexOf(this.state.searchedTerm.toLowerCase()) !== -1;
        }
    )
    return (
        <div>
            <div onClick={this.open} className="searchButton">Search <Glyphicon glyph="search" /></div>
            <Modal show={this.props.isSearch} onHide={this.close} className="searchModal">
                <div id="searchModalHeader">
                    Search
                    <Glyphicon glyph="remove" className="closeLocModal" onClick={this.close} />
                </div>
                <div className="searchContent">
                    <input id="searchInput" type="text" placeholder="Search for locations..." value={this.state.search} onChange={this.updateSearch}></input>
                    <div className="searchOutput">
                        {filteredLocs.map((loc, index) => {
                            return ( <div className="indvSearchOutput" key={index} onClick={() => this.chooseLoc(loc)}>{this.props.markers[loc].name}</div> );
                        })
                        }
                    </div>
                </div>

            </Modal>
        </div>
    );
}
}



// WEBPACK FOOTER //
// ./src/SearchModal.js